import '~/assets/style/pcss/top.pcss';

/* global Splide, ScrollTrigger, gsap */
$(function () {
  /*
   * top detail
   */

  const splide = () => {
    const splideOptions = {
      type: 'loop',
      perPage: 4,
      perMove: 1,
      autoplay: true,
      speed: 600,
      updateOnMove: true,
      direction: 'rtl',
      breakpoints: {
        768: {
          perPage: 2
        }
      }
    };

    new Splide('.js-splide-corporate', splideOptions).mount();
    new Splide('.js-splide-mirait', splideOptions).mount();
  };

  const svgMorphingBg = () => {
    gsap.registerPlugin(MorphSVGPlugin, ScrollTrigger); //eslint-disable-line
    const shape2 = 'M0,0V17S247,50,683,50c431,2,682.92-33,682.92-33V0Z';

    ScrollTrigger.create({
      trigger: '.l-footer__bg',
      start: 'top 70%',
      once: true,
      onEnter: () => {
        gsap.to('#path01', {
          morphSVG: shape2, //eslint-disable-line
          ease: Power3.easeOut, //eslint-disable-line
          duration: 1
        });
        gsap.to('#path02', {
          morphSVG: shape2, //eslint-disable-line
          ease: Power3.easeOut, //eslint-disable-line
          duration: 1
        });
      }
    });
  };

  const topLoadAnim = () => {
    // const tl = gsap.timeline();
    const tl2 = gsap.timeline();
    const tl3 = gsap.timeline();

    const $kvSlide = $('.js-kv-slide');
    // const scaleSize = 0.94;
    let current = 0;

    let transitionFlag = false; //eslint-disable-line
    const disableTarget = '.js-button-disable-target';

    const splideKV = new Splide('.js-splide-kv', {
      type: 'slide',
      rewind: true,
      perPage: 1,
      autoplay: false,
      interval: 6500,
      speed: 1000,
      drag: false,
      keyboard: false,
      pagination: true
    }).mount();

    $('.js-header-inner').animate({
      opacity: 1
    });
    $('.sec__intro').animate({
      opacity: 1
    });
    $kvSlide.eq(current).css({
      opacity: 1
    }).promise().done(function () {
      kvAnimInit();
    });

    function kvAnimInit () {
      if (!document.querySelectorAll('.kv__slide')[0].querySelector('.kv__catch__cont').classList.contains('hidden')) {
        maskTxt(document.querySelectorAll('.kv__slide')[0]);
      }

      splideKV.Components.Autoplay.play();

      splideKV.on('move', () => {
        transitionFlag = true;

        tl2.set('.js-kv-line', {
          autoAlpha: 0
        }).set('.js-kv-catch-txt', {
          autoAlpha: 0
        });
        $('.kv__slide').animate({
          opacity: 0
        }, 500);
      });

      splideKV.on('moved', () => {
        current = splideKV.index;
        document.querySelector('.js-kv-slide-cont').setAttribute('data-current', current);

        setTimeout(() => {
          $('.kv__slide.is-active').animate({
            opacity: 1
          });
          tl3.set('.js-kv-slide-cont', {
            scale: 1
          }).to('.js-kv-slide-cont', {
            duration: 0.2,
            scale: 1
          }).call(() => {
            transitionFlag = false;

            if (!document.querySelectorAll('.kv__slide')[splideKV.index].querySelector('.kv__catch__cont').classList.contains('hidden')) {
              maskTxt(document.querySelectorAll('.kv__slide')[splideKV.index]);
            }

            if ($(disableTarget).attr('disabled', true)) {
              $(disableTarget).attr('disabled', false);
            }
            splideKV.Components.Autoplay.play();
          });
        }, 500);
      });
    }

    function addClassButtonDisableTarget (target) {
      document.querySelectorAll(`${target}`).forEach((el) => {
        el.classList.add('js-button-disable-target');
      });
    }

    addClassButtonDisableTarget('.sec__kv .splide__arrow');
    addClassButtonDisableTarget('.sec__kv .splide__pagination__page');

    document.querySelectorAll(disableTarget).forEach((el) => {
      el.addEventListener('click', () => {
        $(disableTarget).attr('disabled', true);
        splideKV.Components.Autoplay.pause();
      });
      el.addEventListener('mouseenter', () => {
        splideKV.Components.Autoplay.pause();
      });
      el.addEventListener('mouseleave', () => {
        splideKV.Components.Autoplay.pause();
        splideKV.Components.Autoplay.play();
      });
    });

    // let startPosX = null;
    // let endPosX = null;

    // document.querySelector('.sec__kv').addEventListener('touchstart', (e) => {
    //   startPosX = e.changedTouches[0].pageX;
    //   splideKV.Components.Autoplay.pause();
    // });

    // document.querySelector('.sec__kv').addEventListener('touchend', (e) => {
    //   endPosX = e.changedTouches[0].pageX;
    //   splideKV.Components.Autoplay.play();

    //   if(!transitionFlag) {
    //     if(startPosX < endPosX ) {
    //       splideKV.go('-${i}');
    //     }
    //     if( startPosX > endPosX) {
    //       splideKV.go('+${i}');
    //     }
    //   }
    // });

    function maskTxt (ele) {
      tl2.fromTo(ele.querySelectorAll('.js-kv-line'), {
        x: '-200%'
      }, {
        duration: 0.6,
        x: '0%',
        autoAlpha: 1,
        ease: 'Power4.easeOut'
      }, '+=1.0').fromTo(ele.querySelectorAll('.js-kv-line'), {
        scaleX: 1,
        scaleY: 1
      }, {
        duration: 0.4,
        scaleX: 0,
        scaleY: 1,
        ease: 'Power4.easeOut'
      }).to(ele.querySelectorAll('.js-kv-catch-txt'), {
        duration: 0,
        autoAlpha: 1
      }, '-=0.4');
    }
  };

  const pushToLink = function () {
    if ($('.js-push-link').length) {
      $('.js-push-link').on('click', function (e) {
        e.stopPropagation();
        const url = $(this).data('url');
        location.href = url;
        return false;
      });
    }
  };

  const init = function () {
    splide();
    svgMorphingBg();
    topLoadAnim();
    pushToLink();
  };

  init();
});
